export enum TemplateProgress {
  setup = 'setup',
  modifier = 'modifier',
  curves = 'curves',
  embossing = 'embossing',
  render = 'render',
}

export const TemplateProgressOrder: TemplateProgress[] = [
  TemplateProgress.setup,
  TemplateProgress.modifier,
  TemplateProgress.curves,
  TemplateProgress.embossing,
  TemplateProgress.render,
];

export const getTemplateProgressFromIndex = (index: number): TemplateProgress | undefined => {
  return TemplateProgressOrder[index];
};

export enum UploadProgress {
  Select = 'select',
  Orientation = 'orientation',
  Pivot = 'pivot',
}

export const UploadProgressOrder: UploadProgress[] = [
  UploadProgress.Select,
  UploadProgress.Orientation,
  UploadProgress.Pivot,
];

export const getUploadProgressFromIndex = (index: number): UploadProgress | undefined => {
  return UploadProgressOrder[index];
};

export enum OrderProgress {
  setup = 'setup',
  adaptation = 'adaptation',
  crop = 'crop',
  zip = 'zip',
  spacer = 'spacer',
  embossing = 'embossing',
  render = 'render',
}

export const OrderProgressOrder: OrderProgress[] = [
  OrderProgress.setup,
  OrderProgress.adaptation,
  OrderProgress.crop,
  OrderProgress.zip,
  OrderProgress.spacer,
  OrderProgress.embossing,
  OrderProgress.render,
];

export const getOrderProgressFromIndex = (index: number): OrderProgress | undefined => {
  return OrderProgressOrder[index];
};

export enum CustomizeProgress {
  productType = 'productType',
  product = 'product',
  config = 'config',
  visual = 'visual',
  form = 'form',
  overview = 'overview',
}

export const CustomizeProgressOrder: CustomizeProgress[] = [
  CustomizeProgress.productType,
  CustomizeProgress.product,
  CustomizeProgress.config,
  CustomizeProgress.visual,
  CustomizeProgress.form,
  CustomizeProgress.overview,
];

export const getCustomizeProgressFromIndex = (index: number): CustomizeProgress | undefined => {
  return CustomizeProgressOrder[index];
};

// --- NEW: Workflow Registry ---
// This interface defines the structure for each entry in our registry
interface WorkflowDefinition<TStepName extends string> {
  order: TStepName[];
  getFromIndex: (index: number) => TStepName | undefined;
}

// This is the central registry.
// Map<EnumConstructor, WorkflowDefinition>
// We use 'any' for the enum constructor type here because TypeScript has limitations
// when strictly typing Enum constructors as keys in a Map.
export const WorkflowRegistry = new Map<any, WorkflowDefinition<any>>();

// Register each workflow
WorkflowRegistry.set(TemplateProgress, {
  order: TemplateProgressOrder,
  getFromIndex: getTemplateProgressFromIndex
});

WorkflowRegistry.set(UploadProgress, {
  order: UploadProgressOrder,
  getFromIndex: getUploadProgressFromIndex
});

WorkflowRegistry.set(OrderProgress, {
  order: OrderProgressOrder,
  getFromIndex: getOrderProgressFromIndex
});

WorkflowRegistry.set(CustomizeProgress, {
  order: CustomizeProgressOrder,
  getFromIndex: getCustomizeProgressFromIndex
});